<template>
  <div v-if="currentSubscriptions" class="mrbox round border nofill">
    <h1>Toegang tot route(s)</h1>
    <ul>
      <li v-for="subscription in currentSubscriptions" v-bind:key="subscription.SubscriptionId">
        <a :href="subscription.TrailUrl">{{ subscription.Description }}</a>
        (geldig tot en met: {{ moment(subscription.ValidTo).format("D-M-YYYY") }})
      </li>
    </ul>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  data() {
    return {};
  },
  created() {
    this.moment = moment;
  },
  name: 'CustomerSubscription',
  mounted() {
    this.$store.dispatch('getCurrentSingleTrailSubscriptions');
  },
  computed: {
    currentSubscriptions() {
      return this.$store.state.currentSubscriptions;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
